import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { Mic2 } from 'lucide-react';

// Magazine header for the Recorder page: tagline pill + h1 + subtitle.
// Mirrors the layout of ChordsPage / SongsPage / TheoryPage so the
// recorder no longer feels like a different app.

const RecorderHeader = () => {
  const { t } = useTranslation();
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="mb-8"
    >
      <span className="inline-flex items-center gap-2 mb-3 px-3 py-1 rounded-full bg-red-500/10 border border-red-500/30 text-red-400 text-xs font-bold uppercase tracking-widest">
        <Mic2 className="w-3 h-3" />
        {t('recorder.tagline')}
      </span>
      <h1 className="font-heading text-4xl sm:text-5xl font-bold text-white mb-3">
        {t('recorder.title')}
      </h1>
      <p className="text-zinc-400 max-w-2xl">
        {t('recorder.subtitle')}
      </p>
    </motion.div>
  );
};

export default RecorderHeader;
